import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';
import { User, StudentsOrder, SubmitFormInput } from '../../dto';
import { ReqVars } from './common';

type SearchParams = {
  advisorIds?: number[];
  limit?: number;
  offset?: number;
  search?: string;
  order?: StudentsOrder;
  filter?: SubmitFormInput;
  pathIds?: number[];
  excludedIds?: number[];
  caseIds?: string[];
};

type Variables = {
  searchParams: SearchParams;
};

type Results = {
  students: {
    totalCount: number;
    students: User[];
  };
};

const query = gql`
  query getStudentsByCaseIds($searchParams: StudentSearchInput!) {
    students(searchParams: $searchParams) {
      totalCount
      students {
        id
        username
        firstName
        lastName
        phoneNumber
        advisor {
          id
        }
        customProperties {
          id
          value
          type {
            id
            name
            fieldType
          }
        }
        emails {
          id
          email
          primary
        }
      }
    }
  }
`;

export const useStudentsByCaseIds = (options?: ReqVars<QueryHookOptions<Results, Variables>>) =>
  useLazyQuery<Results, Variables>(query, options);

export { query as GET_STUDENTS_BY_CASE_IDS };
